import { AxiosError, AxiosResponse } from 'axios';
import { abortControllerDict, addAbortController, removeAbortController } from '../helpers/axiosHelper';

const cancelTokenRequestInterceptor = async function (config: any) {
   const isGetCall = config.method?.toLowerCase() === 'get';
   const shouldCancel = config.cancelable === false;
   if (shouldCancel || !isGetCall) return config;

   const existingController = abortControllerDict[config.url!];
   if (existingController) {
      existingController.abort(`Canceled duplicate request of ${config.url}`);
   }
   const controller = new AbortController();
   config.signal = controller.signal;

   addAbortController(config.url, controller);

   return config;
};

const cancelTokenResponseSuccessInterceptors = async function (response: AxiosResponse) {
   removeAbortController(response?.config?.url);
   return response;
};
const cancelTokenResponseErrorInterceptors = async function (error: AxiosError) {
   return await Promise.reject(error);
};

export { cancelTokenRequestInterceptor, cancelTokenResponseErrorInterceptors, cancelTokenResponseSuccessInterceptors };
